import { useContext, useMemo, useCallback } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { SORT_BY_DATE } from '@ubeya/shared/utils/sorting';
import { DateRenderer } from 'timeSheet/components/CellRenderers';

// For tableContext === EMPLOYEE_JOB_TAB: first column shows date (using DateRenderer) instead of name
const useDateAsNameColumn = ({ accountId, clickableDate }) => {
  const { t, isRtl } = useContext(ConfigContext);

  const valueGetter = useCallback((params) => params.data?.date ?? '', []);
  const comparator = useCallback((valueA, valueB) => SORT_BY_DATE('date')({ date: valueA }, { date: valueB }), []);

  const cellRenderer = useCallback(
    (params) => {
      if (params.node?.group) return null;
      return DateRenderer({
        rowData: params.data,
        columnData: { accountId, clickableDate }
      });
    },
    [accountId, clickableDate]
  );

  return useMemo(
    () => ({
      field: 'name',
      headerName: t('date'),
      pinned: isRtl ? 'right' : 'left',
      width: 140,
      maxWidth: 140,
      suppressMovable: true,
      suppressColumnsToolPanel: true,
      valueGetter,
      comparator,
      cellRenderer
    }),
    [t, valueGetter, comparator, cellRenderer, isRtl]
  );
};

export default useDateAsNameColumn;
